import { api } from "services/api";
import type { ClassSession } from "types/domain";

export const teachingSessionService = {
  activateSession: async (sessionId: string): Promise<ClassSession> =>
    api.post<ClassSession>(`/sessions/${sessionId}/activate`, {}),

  completeSession: async (sessionId: string): Promise<ClassSession> =>
    api.post<ClassSession>(`/sessions/${sessionId}/complete`, {}),
};